import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { cancelSession, commitSession, createSession, listProfiles } from "../lib/import";

export function useImportProfiles() {
  return useQuery({ queryKey: ["import-profiles"], queryFn: listProfiles });
}

export function useCreateImportSession() {
  return useMutation({
    mutationFn: (p: { file: File; profileCode: string }) => createSession(p.file, p.profileCode),
  });
}

export function useCommitImportSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sessionId: string) => commitSession(sessionId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["investments"] });
      void qc.invalidateQueries({ queryKey: ["cashflows"] });
    },
  });
}

export function useCancelImportSession() {
  return useMutation({ mutationFn: (sessionId: string) => cancelSession(sessionId) });
}
